module.exports = __webpack_public_path__ + "static/media/SignUp_Background.0f741004.png";